import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';

// Web builds are served by the API server, so relative URLs work.
// Native builds load from capacitor://localhost (iOS) / https://localhost (Android)
// and must call the production API explicitly: set REACT_APP_API_URL at build time.
export const isNative = Capacitor.isNativePlatform();
export const API_BASE_URL = process.env.REACT_APP_API_URL || (isNative ? 'https://api.northpoleline.com' : '');
const TOKEN_KEY = 'native_auth_token';
let tokenPromise;

export const loadNativeToken = () => {
  if (!isNative) return Promise.resolve(null);
  if (!tokenPromise) {
    tokenPromise = SecureStorage.get(TOKEN_KEY).catch(error => {
      tokenPromise = null;
      throw error;
    });
  }
  return tokenPromise;
};

export const saveNativeToken = async token => {
  if (!isNative) return;
  if (!token) throw new Error('Native login did not return a token');
  await SecureStorage.set(TOKEN_KEY, token);
  tokenPromise = Promise.resolve(token);
};

export const clearNativeToken = async () => {
  if (!isNative) return;
  await SecureStorage.remove(TOKEN_KEY);
  tokenPromise = Promise.resolve(null);
};

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = !isNative;
axios.interceptors.request.use(async config => {
  if (!isNative) return config;
  config.headers['X-Client-Platform'] = 'native';
  if (!/^\/api\/auth\/(login|signup)$/.test(config.url || '')) {
    const token = await loadNativeToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axios;
